import { render, staticRenderFns } from "./PhaseListComponent.vue?vue&type=template&id=6869c916"
import script from "./PhaseListComponent.vue?vue&type=script&lang=js"
export * from "./PhaseListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports